<template>
  <div class="banner">
    <div
      class="swiper"
      style="overflow: hidden; text-align: center"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in bannerList"
          :key="index"
          @click="toPath(item, index)"
        >
          <img
            :src="item.picPath"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
      <!--
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img src="../../asstes/001.png" style="width: 100%;"/>
                </div>
                <div class="swiper-slide">
                    <img src="../../asstes/001.png" style="width: 100%;"/>
                </div>
            </div>
            -->
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";

export default {
  data() {
    return {
      bannerList: [
        {
          picPath: "https://img.cdn.wxzhida.cn/zd-ali-app/advertisement-pic.jpg",
          url: "https://shop92254760.m.youzan.com/v2/feature/vEViLugtq4",
        },
        // {
        //   picPath: "https://img.cdn.wxzhida.cn/zd-ali-app/klopddr.png",
        //   url: "alipays://platformapi/startapp?appId=2021003146637094&page=pages/activities/index",
        // },
      ],
    };
  },
  mounted() {
     const that = this;
    this.swiperInstance = new Swiper(".swiper", {
      //自动开始
      autoplay: {
        delay: 5000, //时间间隔
        disableOnInteraction: true, //*手动操作轮播图后不会暂停*
      },
      loop: true, // 循环模式选项
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // 分页器可以点击
      },
      // 监听slideChange事件，更新当前索引
      on: {
        slideChange: function () {
          that.currentSlideIndex = this.realIndex; // 保存真实索引
        },
      },
    });
    document.querySelector(".swiper").addEventListener("click", function (e) {
      const slide = e.target.closest(".swiper-slide");
      if (slide) {
        // 获取当前活动幻灯片的真实索引
        const realIndex = that.swiperInstance.realIndex;
        // 获取点击的幻灯片数据
        if (that.bannerList[realIndex]) {
          that.toPath(that.bannerList[realIndex], realIndex);
        }
      }
    });

    // this.getBanner();
  },
  methods: {
    getBanner() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.knowledge.bannerList, {}).then((res) => {
        _.bannerList = res.data.data;
        _.$U.hideLoading(_);
      });
    },
    toPath(item, index) {
      console.log(11111111);
      console.log(index)
      // this.$store.commit('setBannerUrl', val)
      // this.$router.push({name: 'bannerUrl'})
      // window.open("https://u.alipay.cn/_64TliSQsbsEUPRphBSExCA", "_self");
      let _ = this;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // if (index == 1) {
      //   _.$H.post(_, _.$A.knowledge.getActivityOrder, {}).then((res) => {
      //     if (res.data.data != null) {
      //       if (
      //         res.data.data.activityOrderStatus == "COMMIT" &&
      //         res.data.data.address == ""
      //       ) {
      //         if (isiOS) {
      //           _.isApple = true;
      //           console.log(1111);
      //           window.webkit.messageHandlers.app_externalLink.postMessage(
      //             "商品订单"
      //           );
      //         } else if (isAndroid) {
      //           _.isApple = false;
      //           window.jsBridge.app_externalLink("商品订单");
      //         }
      //       } else {
      //         if (isiOS) {
      //           _.isApple = true;
      //           console.log(1111);
      //           window.webkit.messageHandlers.app_externalLink.postMessage(
      //             "商品订单"
      //           );
      //         } else if (isAndroid) {
      //           _.isApple = false;
      //           window.jsBridge.app_externalLink("商品订单");
      //         }
      //       }
      //     } else {
      //       if (isiOS) {
      //         _.isApple = true;
      //         window.webkit.messageHandlers.app_externalLink.postMessage(
      //           item.url
      //         );
      //       } else if (isAndroid) {
      //         _.isApple = false;
      //         window.jsBridge.app_externalLink(item.url);
      //       }
      //     }
      //   });
      // } else {
        if (isiOS) {
          _.isApple = true;
          console.log(1111);
          window.webkit.messageHandlers.app_externalLink.postMessage(item.url);
        } else if (isAndroid) {
          _.isApple = false;
          window.jsBridge.app_externalLink(item.url);
        }
      // }
    },
  },
};
</script>

<style
  scoped
  lang="less"
>
.banner {
  width: 100%;
  height: 156px;
  margin-bottom: 24px;

  .swiper-slide {
    height: 156px;
    overflow: hidden;
    text-align: center;
    display: flex;
    border-radius: 12px;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      // height: 156px;
    }
  }
}
</style>
